const t = "{{currentTime}} из {{duration}}", A = "Результаты поиска {{current}} из {{total}}", n = "Результаты не найдены", o = "{{count}} результат найден", E = "{{count}} результата(-ов) найдено(-ы)", c = 'Начиная с $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) и $t(SECONDS, { "count": {{seconds}} }).', T = 'Начиная с $t(MINUTES, { "count": {{minutes}} }) и $t(SECONDS, { "count": {{seconds}} }).', _ = 'Начиная с $t(SECONDS, { "count": {{seconds}} }).', s = "Произошла ошибка при сохранении изменений в табеле успеваемости.", S = "Строка табеля успеваемости в {{time}}. Содержимое: {{text}}.", N = 'Контейнер строк табеля успеваемости. Имеется $t(TRANSCRIPT_LINES, { "count": {{count}} }) внутри этого контейнера. Для перемещения внутри этого контейнера используйте кнопку со стрелкой вниз.', R = "Сохранение изменений...", O = "Изменения сохранены в табеле успеваемости.", I = "Теперь доступна кнопка «Обновить надписи».", C = "Действие", P = "Добавить аннотацию в {{time}}", U = "Добавить вопрос {{time}}", L = "Аннотации", D = "Авто", e = "Авто ({{quality}})", M = "Назад", u = "Подписи", G = "Язык надписи", Y = "Управление надписями", H = "Удалить {{language}}", r = "Размер шрифта", V = "Язык надписи: {{language}}", B = "{{language}} (автоматически)", i = "Сбросить параметры поиска", a = "Закрыть", K = "Комментарии", m = "Продолжить", F = "Уменьшить скорость воспроизведения", d = "Уменьшить громкость на {{percent}}%", l = "Стрелка вниз", W = "Закрыть редактор табеля успеваемости", $ = "Обновить надписи", g = "Ошибка!", h = "Выполняется сохранение...", Q = "Сохранено!", J = "Редактировать табель успеваемости", p = "Текстовое поле не может быть пустым!", x = "На весь экран", Z = "{{count}} час", X = "{{count}} часа(-ов)", f = "Увеличить скорость воспроизведения", q = "Увеличить громкость на {{percent}}%", v = "Преобразовать цвета", y = "Перейти к конкретному значению в процентах (1-10%, 2-20% и т. д.)", b = "Перейти к запуску", j = "Действия для {{title}}", k = "Клавиши быстрого доступа", w = "Язык", z = "Стрелка влево", tt = "Главное меню", At = "{{count}} минута", nt = "{{count}} минут/минуты", ot = "Скрыть", Et = "Звук отключен", ct = "Следующий язык надписи", Tt = "Следующий результат поиска", _t = "Выкл", st = "Сверху", St = "Открыть аннотацию в {{time}}", Nt = "Открыть выполненный тест в {{time}}", Rt = "Открыть тест в {{time}}", Ot = "Пауза", It = "Воспроизвести", Ct = "Скорость воспроизведения", Pt = "Скорость воспроизведения: {{speed}}x", Ut = "Предыдущий язык надписи", Lt = "Предыдущий результат поиска", Dt = "Качество", et = "Меню Качество", Mt = "Воспроизведение", ut = "Восстановить скорость воспроизведения", Gt = "Стрелка вправо", Yt = "Поиск в табеле успеваемости", Ht = "{{count}} секунда", rt = "{{count}} секунды/секунд", Vt = "Поиск назад: {{seconds}} секунды/секунд", Bt = "Поиск вперед: {{seconds}} секунды/секунд", it = "Настройки", at = "Ярлык", Kt = "Подробная информация о мультимедийных материалах и инструменты", mt = "Пробел", Ft = "Меню Скорость воспроизведения", dt = "Запустить автопрокрутку", lt = "Включить/отключить субтитры", Wt = "Переключение приглушения", $t = "Переключение Воспроизведение/Пауза", gt = "— строка табеля успеваемости {{count}}", ht = "— строки табеля успеваемости {{count}}", Qt = "Выполняется загрузка табеля успеваемости...", Jt = "Нам не удалось загрузить табель успеваемости.", pt = "Параметры табеля успеваемости", xt = "Повторить", Zt = "Табель успеваемости недоступен", Xt = "Стрелка вверх", ft = "Настройки видео", qt = "Объем", vt = "Объем: {{volume}}%", yt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: H,
  CAPTION_FONT_SIZE: r,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: B,
  CLEAR_SEARCH: i,
  CLOSE: a,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: W,
  EDIT_CONFIRM: $,
  EDIT_ERROR: g,
  EDIT_SAVING: h,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: X,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: q,
  INVERT_COLORS: v,
  JUMP_TO_PERCENTAGE: y,
  JUMP_TO_START: b,
  KEBAB_MENU: j,
  KEYBOARD_SHORTCUTS: k,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: Ht,
  SECONDS_other: rt,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: Bt,
  SETTINGS: it,
  SHORTCUT: at,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: Wt,
  TOGGLE_PLAY_PAUSE: $t,
  TRANSCRIPT_LINES: gt,
  TRANSCRIPT_LINES_other: ht,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: Xt,
  VIDEO_SETTINGS: ft,
  VOLUME: qt,
  VOLUME_VALUE: vt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  H as CAPTION_DELETE,
  r as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  B as CAPTION_LANGUAGE_AUTOMATIC,
  i as CLEAR_SEARCH,
  a as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  W as EDIT_CLOSE,
  $ as EDIT_CONFIRM,
  g as EDIT_ERROR,
  h as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  X as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  q as INCREASE_VOLUME,
  v as INVERT_COLORS,
  y as JUMP_TO_PERCENTAGE,
  b as JUMP_TO_START,
  j as KEBAB_MENU,
  k as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ht as SECONDS,
  rt as SECONDS_other,
  Vt as SEEK_BACKWARD,
  Bt as SEEK_FORWARD,
  it as SETTINGS,
  at as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  Wt as TOGGLE_MUTED,
  $t as TOGGLE_PLAY_PAUSE,
  gt as TRANSCRIPT_LINES,
  ht as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  Xt as UP_ARROW,
  ft as VIDEO_SETTINGS,
  qt as VOLUME,
  vt as VOLUME_VALUE,
  yt as default
};
